import APP_ENV from '../../configs/appEnv';
import Request from '../../utils/request';

const PublicRequest = new Request({
  baseURL: APP_ENV.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

PublicRequest._client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default PublicRequest;
